import React from 'react'

import { IColumn } from 'core-components/library/list/types'
import { Tooltip } from 'core-components/library/tooltip'
import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { ThirdPartyLogApplication } from 'onboarding/classes/models/thirdPartyLog'
import { DateHelper } from 'onboarding/utils/dateHelper'

import { applyDefaultFilterByRequestId } from '../helpers/applyDefaultFilterByRequestId'
import styles from '../ThirdPartyLogButton.module.scss'
import { TAdditionalApplicationSourceSettings } from '../types'

export const EMPTY_SOURCE = new Crud({
  keyField: 'id',
  fetcher: new Static<any>([]),
})

export const getRowsPerPageOptions = () => [
  {
    key: 5,
    value: '5',
  },
  {
    key: 10,
    value: '10',
  },
  {
    key: 15,
    value: '15',
  },
]

export const getColumnsByApplication = (application: ThirdPartyLogApplication) => {
  return application === ThirdPartyLogApplication.Securimate
    ? SECURIMATE_LOG_COLUMNS
    : THIRD_PARTY_LOG_COLUMNS
}

export const SECURIMATE_LOG_COLUMNS: IColumn[] = [
  { field: 'Id', title: 'Id' },
  { field: 'PartnerID', title: 'PartnerID' },
  { field: 'SecurimateId', title: 'Old SecurimateId' },
  { field: 'NewSecurimateId', title: 'New SecurimateId' },
  {
    field: 'NewDateTime',
    title: 'Date',
    renderFunction: (item: any) => <div>{DateHelper.convertISOAndFormatToFull(item.DateTime)}</div>,
  },
  {
    field: 'NewUserId',
    title: 'UserId',
  },
]

export const THIRD_PARTY_LOG_COLUMNS: IColumn[] = [
  { field: 'RequestId', title: 'RequestId' },
  { field: 'PartnerId', title: 'PartnerId' },
  { field: 'Application', title: 'Application' },
  { field: 'ActionType', title: 'Action Type' },
  {
    field: 'SentData',
    title: 'Sent Data',
    renderFunction: (item: any) => (
      <Tooltip tipContent={() => <span>{item.SentData}</span>}>
        <div className={styles.logData}>{item.SentData}</div>
      </Tooltip>
    ),
  },
  {
    field: 'ReceivedData',
    title: 'Received Data',
    renderFunction: (item: any) => (
      <Tooltip tipContent={() => <span>{item.ReceivedData}</span>}>
        <div className={styles.logData}>{item.ReceivedData}</div>
      </Tooltip>
    ),
  },
  {
    field: 'Error',
    title: 'Error',
    renderFunction: (item: any) => (
      <Tooltip tipContent={() => <span>{item.Error}</span>}>
        <div className={styles.logData}>{item.Error}</div>
      </Tooltip>
    ),
  },
  {
    field: 'Created',
    title: 'First Requested',
    width: 200,
    renderFunction: (item: any) => <div>{DateHelper.convertISOAndFormatToFull(item.Created)}</div>,
  },
  {
    field: 'Modified',
    title: 'Last Requested',
    width: 200,
    renderFunction: (item: any) => <div>{DateHelper.convertISOAndFormatToFull(item.Modified)}</div>,
  },
]

export const getRequestApplicationSourceSettings = (requestId: number) => {
  const applyFn = (source: Crud) => applyDefaultFilterByRequestId(source, requestId)
  const REQUEST_APPLICATION_SOURCE_SETTINGS: TAdditionalApplicationSourceSettings = {
    [ThirdPartyLogApplication.Exiger]: applyFn,
    [ThirdPartyLogApplication.Portal]: applyFn,
    [ThirdPartyLogApplication.ICertis]: applyFn,
  }

  return REQUEST_APPLICATION_SOURCE_SETTINGS
}
